module.exports = __webpack_public_path__ + "media/images/social-media/facebook-914fe1ebff2c0831f7a6c7e95ae0913a.svg";